import theme from '@/utils/theme'
import { MantineProvider } from '@mantine/core'

const StylesApp = () => {
  return (
    <MantineProvider theme={theme} />
  )
}

export default StylesApp
